import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'rec-public-layout',
  standalone: true,
  imports: [CommonModule, RouterModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="flex min-h-screen flex-col bg-white">
      <header class="border-b border-gray-200 bg-white">
        <div class="container mx-auto flex items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
          <a href="/" class="inline-flex shrink-0" aria-label="Tribuu">
            <img src="https://storage.googleapis.com/tribuu-public/assets/images/logo.png" alt="Tribuu"
              class="h-10 w-auto object-contain sm:h-11 lg:h-12" />
          </a>
        </div>
      </header>
      <main class="flex-1">
        <router-outlet></router-outlet>
      </main>
      <footer class="border-t border-gray-100 bg-white py-4">
        <div class="container mx-auto px-4 text-center font-futura-medium text-xs text-gray-400 sm:px-6 lg:px-8">
          © Tribuu
        </div>
      </footer>
    </div>
  `,
})
export class PublicLayoutComponent {}
